export default {
  label: {
    xAxis: {
      title: 'Canal',
    },
    yAxis: {
      title: 'Respondentes',
    },
    bubble: {
      replier: 'Nombre',
      channel: 'Canal',
      value: 'Valor',
      total: 'Total',
    },
  },
};
